// extracted by mini-css-extract-plugin
export default {"homeSliderSection":"HomeSliderSection_homeSliderSection__qsdBk","homeSliderMarginTop":"HomeSliderSection_homeSliderMarginTop__hb-g0"};